
import { client} from "helpers/client"
import qs from "qs"

// --------------------------------------------------------------- Apps  -------------------------------------------------------------------- //

export const get_apps = params => {
    
    return client('/Apps/FilterApps', {params,paramsSerializer: params => qs.stringify(params)})
}

export const get_app_byId = (appId) => {
    return client(`/Apps/${appId}`)
}


export const get_appTags = () => client('/HomePage/GetPagedList/AppTagsCustomer')
